import { IconMessage } from '@tabler/icons-react';
import { FeedbackState } from '../hooks/usePreSaleVisitFeedback';
import { VisitFeedbackData } from '../hooks/useVisitFeedback';
import { optionLabel } from '../constants/preSaleFeedbackOptions';
import {
  INTEREST_LEVEL_OPTIONS,
  MOVE_IN_OPTIONS,
  PROPERTY_CONDITION_OPTIONS,
  RENT_OBJECTION_OPTIONS,
  SALE_OBJECTION_OPTIONS,
} from '../constants/rentFeedbackOptions';
import { Field } from './VisitDetailParts';

interface Props {
  state: FeedbackState;
  feedback: VisitFeedbackData | null;
  isSale: boolean;
}

const labels = (options: { value: string; label: string }[], values?: string[]) =>
  values?.length ? values.map((v) => optionLabel(options, v)).join(', ') : '';

// "Feedback del Proper" en el detalle de una visita de Renta/Venta finalizada.
const VisitFeedbackCard = ({ state, feedback, isSale }: Props) => (
  <section className="vd-card">
    <header className="vd-card__header">
      <span className="vd-icon vd-icon--green">
        <IconMessage size={20} />
      </span>
      <h2 className="vd-card__title">Feedback del Proper</h2>
      {state === 'done' && (
        <span className="vd-pill vd-pill--success ml-auto">Completado</span>
      )}
      {state === 'pending' && (
        <span className="vd-pill vd-pill--warning ml-auto">Pendiente</span>
      )}
    </header>

    {state === 'loading' && <p className="mb-0 text-muted">Cargando…</p>}
    {state === 'error' && (
      <p className="mb-0 text-muted">No se pudo cargar el feedback.</p>
    )}
    {state === 'pending' && (
      <p className="vd-locked__text mb-0">
        Esta visita se cerró sin feedback del Proper.
      </p>
    )}
    {state === 'done' && feedback && (
      <div className="vd-grid">
        <Field label={isSale ? 'Interés del comprador' : 'Interés del inquilino'}>
          {optionLabel(INTEREST_LEVEL_OPTIONS, feedback.interest_level)}
        </Field>
        <Field label="Estado de la propiedad">
          {labels(PROPERTY_CONDITION_OPTIONS, feedback.property_condition)}
        </Field>
        <Field label="Objeciones">
          {labels(
            isSale ? SALE_OBJECTION_OPTIONS : RENT_OBJECTION_OPTIONS,
            feedback.objections,
          )}
        </Field>
        {!isSale && (
          <Field label="Mudanza">
            {feedback.move_in_timeframe
              ? optionLabel(MOVE_IN_OPTIONS, feedback.move_in_timeframe)
              : ''}
          </Field>
        )}
        {isSale && feedback.logistics_issue && (
          <Field label="Problema logístico">
            {feedback.logistics_issue.had_issue
              ? feedback.logistics_issue.details || 'Sí'
              : 'No'}
          </Field>
        )}
        <Field label="Recomendación al propietario">
          {feedback.owner_recommendation}
        </Field>
      </div>
    )}
  </section>
);

export default VisitFeedbackCard;
